import $ from "jquery";
import { createFolderSelector } from "../components/media/folderSelector.js";
import { __ } from "../utils/i18n.js";
function runPreUploadUi(el, data) {
    const compatView = !!$(el).parent(".rml-compat-preUploadUi").length;
    let attachmentsBrowser = $(el).parents(".attachments-browser");
    compatView && !attachmentsBrowser.length && (attachmentsBrowser = $(".attachments-browser"));
    if (attachmentsBrowser.length && !compatView) {
        $(el).parent().hide().prev().html(__("The file is uploaded to the folder where you are currently in."));
    } else {
        const span = $("<span/>").addClass(compatView ? undefined : "attachments-filter-preUploadUi").insertAfter($(el)).get(0);
        createFolderSelector(span, el, Object.assign(data, {
            style: {
                maxWidth: 400
            },
            onSelect: compatView && function(_node, input) {
                attachmentsBrowser.data("backboneView")?.controller.once("attachment:compat:ready", ()=>window.rml.store.fetchCounts());
                $(input).trigger("change");
            }
        }));
    }
}
function mountPreUploadUi(el) {
    runPreUploadUi(el, $(el).data());
}
export { mountPreUploadUi };
